import { readableColor } from 'polished';
import { white, black } from 'Styles/colors';

/**
 * CSS rules to create ADA readable text color
 *
 * @param {string} backgroundColor Hex value of background color
 */
export default (backgroundColor) =>
  `
  background: ${backgroundColor};
  color: ${readableColor(backgroundColor, white, black)};
  `;
